import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpMainService } from "../http-main.service";
import { TokensResponseModel } from "@itb-monorepo/models";
import { LoginRequestModel } from "@itb-monorepo/models";
import { AUTH_SCOPE_TOKEN } from '@itb-monorepo/enums';

@Injectable({
  providedIn: 'root',
})
export class TokensService {
  private _HttpMainService = inject(HttpMainService);
  private scope = inject(AUTH_SCOPE_TOKEN);

  baseUrl = '/member/';

  refreshAccessToken(): Observable<TokensResponseModel> {
    return this._HttpMainService.put(
      this.baseUrl + `v1/${this.scope}/-/tokens`
    );
  }

  loginUser(model: LoginRequestModel): Observable<TokensResponseModel> {
    return this._HttpMainService.post(
      this.baseUrl + `v1/${this.scope}/-/tokens`,
      model
    );
  }

  logoutUser(): Observable<null> {
    return this._HttpMainService.delete(this.baseUrl + 'v1/tokens/current');
  }
}
